import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import Wrapper from '../layouts/Wrapper';
import Banner from '../components/laboratory/Banner';
import SectionsInfo from '../components/SectionsInfo';
import CustomAccordion from '../components/laboratory/CustomAccordion';
import { getLaboratoryPage } from '../store/actions/laboratoryPage';
import Spinner from '../components/Spinner';
import removeHtmlTags from '../helpers/removeHtmlTags';

function Laboratory() {
  const dispatch = useDispatch();
  const lang = Cookies.get('i18next') || 'en';
  const { data, loading } = useSelector((state) => state.laboratoryPage);
  useEffect(() => {
    dispatch(getLaboratoryPage());
  }, []);
  return (
    <Wrapper>
      {!loading ? (
        <div className="container medium">
          <Banner
            title={data.laboratory.title[lang]}
            description={removeHtmlTags(data.laboratory.summary[lang])}
            bannerImage={data.laboratory.image.webp_url}
          />
          <div className="rooms_content">
            <SectionsInfo
              isSlider={false}
              isPartner={false}
              title={data?.laboratory?.two_blog_title ? data.laboratory.two_blog_title[lang] : ''}
            />
            <CustomAccordion data={data.laboratoryServiceList} room="laboratories" />
          </div>
        </div>
      ) : <Spinner width={100} height={100} />}
    </Wrapper>
  );
}

export default Laboratory;
